import React, { Component } from 'react';

class Breadcrumbs extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <React.Fragment>
                {this.props.breadcrumbProps !== undefined ? (
                    <div className="breadcrumbs">
                        <ul>
                            {this.props.breadcrumbProps.map((breadcrumb, index) => {
                                return (
                                    <li key={index}>
                                        {(index === this.props.breadcrumbProps.length - 1) ? (
                                            <span>{breadcrumb.Name}</span>
                                        ) : (
                                            <a href={breadcrumb.Link}>{breadcrumb.Name}</a>
                                        )}
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                ) : null}
            </React.Fragment>
        );
    }
}
export default Breadcrumbs;
